// THE PLATFORM'S ENTRY FILE, not authored surface: the box restores it from the template on every
// sync and `isAgentAppWritable` refuses a write to it, the same way it refuses `src/lib/apollo.ts`.
//
// It looks like boilerplate and it is not. The one decision in it — whether `<App/>` mounts AT ALL —
// belongs to the platform, because it is the answer to a question no authored route can answer for
// itself: in an app where every role is the owner's to grant, a person who has just signed up holds
// nothing, every screen refuses them, and the app's own landing sends them back to the screen that
// refused them. The gate below renders the truth instead, before any authored route loads, so it does
// not matter which route the author chose as the index.

import { createRoot } from 'react-dom/client';
import { ApolloProvider } from '@apollo/client/react';
import { apolloClient } from './lib/apollo';
import { APP_ACCESS } from './lib/gql/__generated__/app-access';
import { AccessGate } from './lib/platform/access-gate';
import { reportCaughtError } from './lib/platform/caught-error';
import { App } from './App';
import { Toaster } from './components/ui/sonner';
import './index.css';

// `onCaughtError` is the second decision this file carries, and it is the platform's for the same
// reason the gate is: the boundary that catches a crashed ROUTE belongs to TanStack, not to the app,
// and its `onCatch` is undefined in a production build — so a route that threw in render reported
// nothing anywhere while still stamping `data-app-ready`. React fires this for every boundary in the
// root, which is the only place that covers all of them. See `./lib/platform/caught-error`.
createRoot(document.getElementById('root')!, { onCaughtError: reportCaughtError }).render(
  <ApolloProvider client={apolloClient}>
    <AccessGate access={APP_ACCESS}>
      <App />
    </AccessGate>
    <Toaster />
  </ApolloProvider>,
);
